<i class="fa-solid fa-file-csv csv-btn" (click)="exportCSV()"></i>